// @ts-nocheck
// ============================================================
// ROUTE GUARD — Fase 11.6
// Protege rotas enterprise com verificação de permissão
// /twin, /vision/cameras, /executive, /war-room
// ============================================================

export type RoutePermission =
  | 'twin:view'
  | 'vision:view'
  | 'executive:view'
  | 'executive:war_room'
  | 'admin'

export interface UserRole {
  role:       'viewer' | 'operator' | 'manager' | 'executive' | 'admin'
  company_id: string
  obra_ids:   string[]   // scoped access
}

const ROUTE_PERMISSIONS: Record<string, RoutePermission[]> = {
  '/twin':                 ['twin:view'],
  '/vision/cameras':       ['vision:view'],
  '/executive':            ['executive:view'],
  '/executive/war-room':   ['executive:war_room'],
}

const ROLE_GRANTS: Record<UserRole['role'], RoutePermission[]> = {
  viewer:    [],
  operator:  ['vision:view', 'twin:view'],
  manager:   ['vision:view', 'twin:view', 'executive:view'],
  executive: ['vision:view', 'twin:view', 'executive:view', 'executive:war_room'],
  admin:     ['vision:view', 'twin:view', 'executive:view', 'executive:war_room', 'admin'],
}

export function hasPermission(
  userRole: UserRole | null,
  permission: RoutePermission,
): boolean {
  if (!userRole) return false
  return ROLE_GRANTS[userRole.role]?.includes(permission) ?? false
}

export function canAccessRoute(
  userRole: UserRole | null,
  path:     string,
): boolean {
  const required = ROUTE_PERMISSIONS[path]
  if (!required || required.length === 0) return true  // unguarded route
  return required.every(p => hasPermission(userRole, p))
}

export function canAccessObra(
  userRole: UserRole | null,
  obraId:   string,
): boolean {
  if (!userRole) return false
  if (userRole.role === 'admin') return true
  return userRole.obra_ids.includes(obraId)
}
